import { Stack } from '@legacy/components/mui-components';
import { Shimmer } from '@legacy/components/ui-components/Shimmer';

export const Loading = () => (
  <Stack data-automation-id="MilestonesLoadMessage">
    <Shimmer width="thirdQuarter" />
    <Shimmer width="full" />
    <Shimmer width="half" />
    <Shimmer width="thirdQuarter" />
  </Stack>
);
